export const loginCopy = {
  title: "Logg inn",
  subtitle:
    "Åpne Forhandlerbørsen og selg direkte til proffene med passkey, e-postkode eller SMS.",
  passkeyButton: "Fortsett med passkey",
  divider: "eller fortsett med",
  emailTab: "E-post",
  smsTab: "SMS",
  emailLabel: "E-postadresse",
  emailPlaceholder: "navn@forhandler.no",
  otpLabel: "Engangskode",
  phoneLabel: "Mobilnummer",
  phonePlaceholder: "900 00 000",
  otpSmsLabel: "SMS-kode",
  submitSend: "Send kode",
  submitSignIn: "Logg inn",
  resendCode: "Send på nytt",
  changeEmail: "Bytt e-post",
  changePhone: "Bytt nummer",
  sending: "Sender...",
  verifying: "Verifiserer...",
  footerTitle: "Innbyttebiler? Selg direkte til proffene.",
  footerSubtitle:
    "Norges mest effektive plattform for profesjonell bilhandel. Logg inn for å håndtere innlevering, lukket budgiving og full oversikt på ett sted.",
  usersCount: "Nasjonalt nettverk",
  trustPlatform: "av verifiserte forhandlere",
  errors: {
    generic: "Noe gikk galt under innloggingen. Prøv en gang til.",
    emailRequired: "Skriv inn e-postadressen din for å få tilsendt kode.",
    phoneRequired: "Skriv inn mobilnummeret ditt for å få tilsendt kode.",
    invalidPhone: "Skriv inn et gyldig mobilnummer.",
    invalidOtp: "Koden ser ikke riktig ut. Kontroller de 6 sifrene og prøv igjen.",
    verificationFailed:
      "Vi klarte ikke å bekrefte koden. Be om en ny kode og prøv igjen.",
    userNotFound:
      "Vi fant ingen bruker med denne e-posten eller dette mobilnummeret.",
    network: "Vi fikk ikke kontakt med serveren. Sjekk forbindelsen og prøv igjen.",
  },
};

export function getFriendlyErrorMessage(
  message: string | undefined,
  t: typeof loginCopy,
) {
  const normalized = (message ?? "").trim().toLowerCase();

  if (!normalized) return t.errors.generic;
  if (normalized.includes("user not found")) return t.errors.userNotFound;
  if (normalized.includes("invalid otp") || normalized.includes("invalid code")) {
    return t.errors.invalidOtp;
  }
  if (normalized.includes("failed to verify") || normalized.includes("verification failed")) {
    return t.errors.verificationFailed;
  }
  if (normalized.includes("network") || normalized.includes("fetch")) {
    return t.errors.network;
  }

  return t.errors.generic;
}
